import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { OAuthAuthorizeParams } from 'shared';

import {
  approveOAuthAuthorization,
  denyOAuthAuthorization,
  revokeOAuthGrant,
} from '../../lib/api/endpoints';

import { oauthKeys } from './queries';

export function useOAuthDecision() {
  return useMutation({
    mutationFn: (input: { params: OAuthAuthorizeParams; approve: boolean }) =>
      input.approve
        ? approveOAuthAuthorization(input.params)
        : denyOAuthAuthorization(input.params),
    onSuccess: (result) => {
      window.location.assign(result.redirectTo);
    },
  });
}

export function useRevokeOAuthGrant() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => revokeOAuthGrant(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: oauthKeys.grants() });
    },
  });
}
